"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vesselInfo = require("@/api/vesselInfo/vesselInfo");
var _validate = require("@/utils/validate");
var _date = require("@/utils/date");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'vesselInfo',
  data: function data() {
    return {
      form: {
        vesselCode: '',
        vesselName: '',
        callSign: '',
        rowStart: 1,
        pageSize: 20
      },
      vesselInfo: {
        vesselCode: undefined,
        vesselName: undefined,
        callSign: undefined,
        vesselNationality: undefined,
        imoCode: undefined,
        classfication: undefined,
        grossTon: undefined,
        netTon: undefined,
        dwt: undefined,
        totalTeu: undefined,
        buildDate: undefined
      },
      isResult: false,
      loading: null
    };
  },
  methods: {
    validateNull: _validate.validateNull,
    dateFormat: _date.dateFormat,
    vesselCodeChange: function vesselCodeChange(value, selectedRows) {
      this.form.vesselCode = selectedRows.vesselCode;
    },
    vesselNameChange: function vesselNameChange(value, selectedRows) {
      this.form.vesselName = selectedRows.vesselName;
    },
    toSearch: function toSearch() {
      var _this = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          if (!(0, _validate.validateNull)(_this.form.vesselCode) || !(0, _validate.validateNull)(_this.form.vesselName) || !(0, _validate.validateNull)(_this.form.callSign)) {
            _this.loading = (0, _utils.load)();
            (0, _vesselInfo.vesselInfoSearch)(_this.form).then(function (response) {
              if (!(0, _validate.validateNull)(response.data.list)) {
                _this.vesselInfo = response.data.list;
                _this.isResult = true;
              } else {
                _this.vesselInfo = [];
                _this.isResult = true;
              }
            }).catch(function () {
              _this.vesselInfo = [];
              _this.isResult = true;
            }).finally(function () {
              _this.loading.close();
            });
          } else {
            _this.$message({
              message: _this.$t('vesselInfo.validateNul'),
              center: true,
              offset: 70
            });
          }
        }
      });
    },
    formatDate: function formatDate(row, column, cellValue, index) {
      row.buildDate = (0, _date.dateFormat)('YYYY', row.buildDate);
      return row.buildDate;
    }
  }
};